Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.interpolateColor = exports.Extrapolate = exports.ColorSpace = void 0;
exports.useInterpolateConfig = useInterpolateConfig;
var _Colors = require("./Colors");
var _core = require("./core");
var _interpolation = require("./interpolation");
var _useSharedValue = require("./hook/useSharedValue");
var Extrapolate = exports.Extrapolate = {
    EXTEND: "extend",
    CLAMP: "clamp",
    IDENTITY: "identity"
};
var _worklet_7572958361989_init_data = {
    code: "function anonymous(value,inputRange,colors,options){const{interpolate,Extrapolate,hsvToColor}=this.__closure;let h=0;const{useCorrectedHSVInterpolation=true}=options;if(useCorrectedHSVInterpolation){const correctedInputRange=[inputRange[0]];const originalH=colors.h;const correctedH=[originalH[0]];for(let i=1;i<originalH.length;++i){const d=originalH[i]-originalH[i-1];if(originalH[i]>originalH[i-1]&&d>0.5){correctedInputRange.push(inputRange[i]);correctedInputRange.push(inputRange[i]+0.00001);correctedH.push(originalH[i]-1);correctedH.push(originalH[i]);}else if(originalH[i]<originalH[i-1]&&d<-0.5){correctedInputRange.push(inputRange[i]);correctedInputRange.push(inputRange[i]+0.00001);correctedH.push(originalH[i]+1);correctedH.push(originalH[i]);}else{correctedInputRange.push(inputRange[i]);correctedH.push(originalH[i]);}}h=(interpolate(value,correctedInputRange,correctedH,Extrapolate.CLAMP)+1)%1;}else{h=interpolate(value,inputRange,colors.h,Extrapolate.CLAMP);}const s=interpolate(value,inputRange,colors.s,Extrapolate.CLAMP);const v=interpolate(value,inputRange,colors.v,Extrapolate.CLAMP);const a=interpolate(value,inputRange,colors.a,Extrapolate.CLAMP);return hsvToColor(h,s,v,a);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts",
    sourceMap: '{"version":3,"names":["anonymous","value","inputRange","colors","options","interpolate","Extrapolate","hsvToColor","__closure","h","useCorrectedHSVInterpolation","correctedInputRange","originalH","correctedH","i","length","d","push","CLAMP","s","v","a"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts"],"mappings":"AA0B6B,QAC3B,CAAAA,SACAA,CAAAC,KAAA,CAAAC,UACsB,CACtBC,MAAA,CAA6BC,OAC1B,QAAAC,WAAA,CAAAC,WAAA,CAAAC,UAAA,OAAAC,SAAA,CAEH,GAAI,CAAAC,CAAC,CAAG,CAAC,CACT,KAAM,CAAEC,4BAA4B,CAAG,IAAK,CAAC,CAAGN,OAAO,CACvD,GAAIM,4BAA4B,CAAE,CAKhC,KAAM,CAAAC,mBAAmB,CAAG,CAACT,UAAU,CAAC,CAAC,CAAC,CAAC,CAC3C,KAAM,CAAAU,SAAS,CAAGT,MAAM,CAACM,CAAC,CAC1B,KAAM,CAAAI,UAAU,CAAG,CAACD,SAAS,CAAC,CAAC,CAAC,CAAC,CAEjC,IAAK,GAAI,CAAAE,CAAC,CAAG,CAAC,CAAEA,CAAC,CAAGF,SAAS,CAACG,MAAM,CAAE,EAAED,CAAC,CAAE,CACzC,KAAM,CAAAE,CAAC,CAAGJ,SAAS,CAACE,CAAC,CAAC,CAAGF,SAAS,CAACE,CAAC,CAAG,CAAC,CAAC,CACzC,GAAIF,SAAS,CAACE,CAAC,CAAC,CAAGF,SAAS,CAACE,CAAC,CAAG,CAAC,CAAC,EAAIE,CAAC,CAAG,GAAG,CAAE,CAC9CL,mBAAmB,CAACM,IAAI,CAACf,UAAU,CAACY,CAAC,CAAC,CAAC,CACvCH,mBAAmB,CAACM,IAAI,CAACf,UAAU,CAACY,CAAC,CAAC,CAAG,OAAO,CAAC,CACjDD,UAAU,CAACI,IAAI,CAACL,SAAS,CAACE,CAAC,CAAC,CAAG,CAAC,CAAC,CACjCD,UAAU,CAACI,IAAI,CAACL,SAAS,CAACE,CAAC,CAAC,CAAC,CAC/B,CAAC,IAAM,IAAIF,SAAS,CAACE,CAAC,CAAC,CAAGF,SAAS,CAACE,CAAC,CAAG,CAAC,CAAC,EAAIE,CAAC,CAAG,CAAC,GAAG,CAAE,CACtDL,mBAAmB,CAACM,IAAI,CAACf,UAAU,CAACY,CAAC,CAAC,CAAC,CACvCH,mBAAmB,CAACM,IAAI,CAACf,UAAU,CAACY,CAAC,CAAC,CAAG,OAAO,CAAC,CACjDD,UAAU,CAACI,IAAI,CAACL,SAAS,CAACE,CAAC,CAAC,CAAG,CAAC,CAAC,CACjCD,UAAU,CAACI,IAAI,CAACL,SAAS,CAACE,CAAC,CAAC,CAAC,CAC/B,CAAC,IAAM,CACLH,mBAAmB,CAACM,IAAI,CAACf,UAAU,CAACY,CAAC,CAAC,CAAC,CACvCD,UAAU,CAACI,IAAI,CAACL,SAAS,CAACE,CAAC,CAAC,CAAC,CAC/B,CACF,CACAL,CAAC,CACC,CAACJ,WAAW,CAACJ,KAAK,CAAEU,mBAAmB,CAAEE,UAAU,CAAEP,WAAW,CAACY,KAAK,CAAC,CACrE,CAAC,EACH,CAAC,CACL,CAAC,IAAM,CACLT,CAAC,CAAGJ,WAAW,CAACJ,KAAK,CAAEC,UAAU,CAAEC,MAAM,CAACM,CAAC,CAAEH,WAAW,CAACY,KAAK,CAAC,CACjE,CACA,KAAM,CAAAC,CAAC,CAAGd,WAAW,CAACJ,KAAK,CAAEC,UAAU,CAAEC,MAAM,CAACgB,CAAC,CAAEb,WAAW,CAACY,KAAK,CAAC,CACrE,KAAM,CAAAE,CAAC,CAAGf,WAAW,CAACJ,KAAK,CAAEC,UAAU,CAAEC,MAAM,CAACiB,CAAC,CAAEd,WAAW,CAACY,KAAK,CAAC,CACrE,KAAM,CAAAG,CAAC,CAAGhB,WAAW,CAACJ,KAAK,CAAEC,UAAU,CAAEC,MAAM,CAACkB,CAAC,CAAEf,WAAW,CAACY,KAAK,CAAC,CACrE,MAAO,CAAAX,UAAU,CAACE,CAAC,CAAEU,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAAC,CAC/B"}',
    version: "3.5.4"
};
var interpolateColorsHSV = function() {
    var _e = [
        new global.Error(),
        -4,
        -27
    ];
    var anonymous = function anonymous(value, inputRange, colors, options) {
        var h = 0;
        var _options$useCorrected = options.useCorrectedHSVInterpolation, useCorrectedHSVInterpolation = _options$useCorrected === void 0 ? true : _options$useCorrected;
        if (useCorrectedHSVInterpolation) {
            var correctedInputRange = [
                inputRange[0]
            ];
            var originalH = colors.h;
            var correctedH = [
                originalH[0]
            ];
            for(var i = 1; i < originalH.length; ++i){
                var d = originalH[i] - originalH[i - 1];
                if (originalH[i] > originalH[i - 1] && d > 0.5) {
                    correctedInputRange.push(inputRange[i]);
                    correctedInputRange.push(inputRange[i] + 0.00001);
                    correctedH.push(originalH[i] - 1);
                    correctedH.push(originalH[i]);
                } else if (originalH[i] < originalH[i - 1] && d < -0.5) {
                    correctedInputRange.push(inputRange[i]);
                    correctedInputRange.push(inputRange[i] + 0.00001);
                    correctedH.push(originalH[i] + 1);
                    correctedH.push(originalH[i]);
                } else {
                    correctedInputRange.push(inputRange[i]);
                    correctedH.push(originalH[i]);
                }
            }
            h = ((0, _interpolation.interpolate)(value, correctedInputRange, correctedH, Extrapolate.CLAMP) + 1) % 1;
        } else {
            h = (0, _interpolation.interpolate)(value, inputRange, colors.h, Extrapolate.CLAMP);
        }
        var s = (0, _interpolation.interpolate)(value, inputRange, colors.s, Extrapolate.CLAMP);
        var v = (0, _interpolation.interpolate)(value, inputRange, colors.v, Extrapolate.CLAMP);
        var a = (0, _interpolation.interpolate)(value, inputRange, colors.a, Extrapolate.CLAMP);
        return (0, _Colors.hsvToColor)(h, s, v, a);
    };
    anonymous.__closure = {
        interpolate: _interpolation.interpolate,
        Extrapolate: Extrapolate,
        hsvToColor: _Colors.hsvToColor
    };
    anonymous.__initData = _worklet_7572958361989_init_data;
    anonymous.__workletHash = 7572958361989;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_9548966570765_init_data = {
    code: "function anonymous(x,gamma){return x.map(function(v){return Math.pow(v/255,gamma);});}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts",
    sourceMap: '{"version":3,"names":["anonymous","x","gamma","map","v","Math","pow"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts"],"mappings":"AA0EsB,QAAC,CAAAA,SAAaA,CAAcC,CAAA,CAAcC,KAAA,EAE9D,MAAO,CAAAD,CAAC,CAACE,GAAG,CAAE,SAAAC,CAAC,QAAK,CAAAC,IAAI,CAACC,GAAG,CAACF,CAAC,CAAG,GAAG,CAAEF,KAAK,CAAC,GAAC,CAC/C"}',
    version: "3.5.4"
};
var toLinearSpace = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var anonymous = function anonymous(x, gamma) {
        return x.map(function(v) {
            return Math.pow(v / 255, gamma);
        });
    };
    anonymous.__closure = {};
    anonymous.__initData = _worklet_9548966570765_init_data;
    anonymous.__workletHash = 9548966570765;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_12849438514316_init_data = {
    code: "function anonymous(x,gamma){return Math.round(Math.pow(x,1/gamma)*255);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts",
    sourceMap: '{"version":3,"names":["anonymous","x","gamma","Math","round","pow"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts"],"mappings":"AA+EqB,QAAC,CAAAA,SAAWA,CAAcC,CAAA,CAAYC,KAAA,EAEzD,MAAO,CAAAC,IAAI,CAACC,KAAK,CAACD,IAAI,CAACE,GAAG,CAACJ,CAAC,CAAE,CAAC,CAAGC,KAAK,CAAC,CAAG,GAAG,CAAC,CACjD"}',
    version: "3.5.4"
};
var toGammaSpace = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var anonymous = function anonymous(x, gamma) {
        return Math.round(Math.pow(x, 1 / gamma) * 255);
    };
    anonymous.__closure = {};
    anonymous.__initData = _worklet_12849438514316_init_data;
    anonymous.__workletHash = 12849438514316;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_684264391002_init_data = {
    code: "function anonymous(value,inputRange,colors,options){const{toLinearSpace,interpolate,Extrapolate,rgbaColor,toGammaSpace}=this.__closure;const{gamma=2.2}=options;let{r:outputR,g:outputG,b:outputB}=colors;if(gamma!==1){outputR=toLinearSpace(outputR,gamma);outputG=toLinearSpace(outputG,gamma);outputB=toLinearSpace(outputB,gamma);}const r=interpolate(value,inputRange,outputR,Extrapolate.CLAMP);const g=interpolate(value,inputRange,outputG,Extrapolate.CLAMP);const b=interpolate(value,inputRange,outputB,Extrapolate.CLAMP);const a=interpolate(value,inputRange,colors.a,Extrapolate.CLAMP);if(gamma===1){return rgbaColor(r,g,b,a);}return rgbaColor(toGammaSpace(r,gamma),toGammaSpace(g,gamma),toGammaSpace(b,gamma),a);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts",
    sourceMap: '{"version":3,"names":["anonymous","value","inputRange","colors","options","toLinearSpace","interpolate","Extrapolate","rgbaColor","toGammaSpace","__closure","gamma","r","outputR","g","outputG","b","outputB","CLAMP","a"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts"],"mappings":"AAoF6B,QAC3B,CAAAA,SACAA,CAAAC,KAAA,CAAAC,UACsB,CACtBC,MAAA,CAA6BC,OAC1B,QAAAC,aAAA,CAAAC,WAAA,CAAAC,WAAA,CAAAC,SAAA,CAAAC,YAAA,OAAAC,SAAA,CAEH,KAAM,CAAEC,KAAK,CAAG,GAAI,CAAC,CAAGP,OAAO,CAC/B,GAAI,CAAEQ,CAAC,CAAEC,OAAO,CAAEC,CAAC,CAAEC,OAAO,CAAEC,CAAC,CAAEC,OAAQ,CAAC,CAAGd,MAAM,CACnD,GAAIQ,KAAK,GAAK,CAAC,CAAE,CACfE,OAAO,CAAGR,aAAa,CAACQ,OAAO,CAAEF,KAAK,CAAC,CACvCI,OAAO,CAAGV,aAAa,CAACU,OAAO,CAAEJ,KAAK,CAAC,CACvCM,OAAO,CAAGZ,aAAa,CAACY,OAAO,CAAEN,KAAK,CAAC,CACzC,CACA,KAAM,CAAAC,CAAC,CAAGN,WAAW,CAACL,KAAK,CAAEC,UAAU,CAAEW,OAAO,CAAEN,WAAW,CAACW,KAAK,CAAC,CACpE,KAAM,CAAAJ,CAAC,CAAGR,WAAW,CAACL,KAAK,CAAEC,UAAU,CAAEa,OAAO,CAAER,WAAW,CAACW,KAAK,CAAC,CACpE,KAAM,CAAAF,CAAC,CAAGV,WAAW,CAACL,KAAK,CAAEC,UAAU,CAAEe,OAAO,CAAEV,WAAW,CAACW,KAAK,CAAC,CACpE,KAAM,CAAAC,CAAC,CAAGb,WAAW,CAACL,KAAK,CAAEC,UAAU,CAAEC,MAAM,CAACgB,CAAC,CAAEZ,WAAW,CAACW,KAAK,CAAC,CACrE,GAAIP,KAAK,GAAK,CAAC,CAAE,CACf,MAAO,CAAAH,SAAS,CAACI,CAAC,CAAEE,CAAC,CAAEE,CAAC,CAAEG,CAAC,CAAC,CAC9B,CACA,MAAO,CAAAX,SAAS,CACdC,YAAY,CAACG,CAAC,CAAED,KAAK,CAAC,CACtBF,YAAY,CAACK,CAAC,CAAEH,KAAK,CAAC,CACtBF,YAAY,CAACO,CAAC,CAAEL,KAAK,CAAC,CACtBQ,CACF,CAAC,CACH"}',
    version: "3.5.4"
};
var interpolateColorsRGB = function() {
    var _e = [
        new global.Error(),
        -6,
        -27
    ];
    var anonymous = function anonymous(value, inputRange, colors, options) {
        var _options$gamma = options.gamma, gamma = _options$gamma === void 0 ? 2.2 : _options$gamma;
        var outputR = colors.r, outputG = colors.g, outputB = colors.b;
        if (gamma !== 1) {
            outputR = toLinearSpace(outputR, gamma);
            outputG = toLinearSpace(outputG, gamma);
            outputB = toLinearSpace(outputB, gamma);
        }
        var r = (0, _interpolation.interpolate)(value, inputRange, outputR, Extrapolate.CLAMP);
        var g = (0, _interpolation.interpolate)(value, inputRange, outputG, Extrapolate.CLAMP);
        var b = (0, _interpolation.interpolate)(value, inputRange, outputB, Extrapolate.CLAMP);
        var a = (0, _interpolation.interpolate)(value, inputRange, colors.a, Extrapolate.CLAMP);
        if (gamma === 1) {
            return (0, _Colors.rgbaColor)(r, g, b, a);
        }
        return (0, _Colors.rgbaColor)(toGammaSpace(r, gamma), toGammaSpace(g, gamma), toGammaSpace(b, gamma), a);
    };
    anonymous.__closure = {
        toLinearSpace: toLinearSpace,
        interpolate: _interpolation.interpolate,
        Extrapolate: Extrapolate,
        rgbaColor: _Colors.rgbaColor,
        toGammaSpace: toGammaSpace
    };
    anonymous.__initData = _worklet_684264391002_init_data;
    anonymous.__workletHash = 684264391002;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_8695722846819_init_data = {
    code: "function anonymous(colors){const{processColor,red,green,blue,opacity}=this.__closure;const r=[];const g=[];const b=[];const a=[];for(let i=0;i<colors.length;++i){const color=colors[i];const processedColor=processColor(color);if(processedColor!==null&&processedColor!==undefined){r.push(red(processedColor));g.push(green(processedColor));b.push(blue(processedColor));a.push(opacity(processedColor));}}return{r:r,g:g,b:b,a:a};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts",
    sourceMap: '{"version":3,"names":["anonymous","colors","processColor","red","green","blue","opacity","__closure","r","g","b","a","i","length","color","processedColor","undefined","push"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts"],"mappings":"AAwH0B,QACxB,CAAAA,SACDA,CAAoBC,MAAA,QAAAC,YAAA,CAAAC,GAAA,CAAAC,KAAA,CAAAC,IAAA,CAAAC,OAAA,OAAAC,SAAA,CAGnB,KAAM,CAAAC,CAAC,CAAG,EAAE,CACZ,KAAM,CAAAC,CAAC,CAAG,EAAE,CACZ,KAAM,CAAAC,CAAC,CAAG,EAAE,CACZ,KAAM,CAAAC,CAAC,CAAG,EAAE,CACZ,IAAK,GAAI,CAAAC,CAAC,CAAG,CAAC,CAAEA,CAAC,CAAGX,MAAM,CAACY,MAAM,CAAE,EAAED,CAAC,CAAE,CACtC,KAAM,CAAAE,KAAK,CAAGb,MAAM,CAACW,CAAC,CAAC,CACvB,KAAM,CAAAG,cAAc,CAAGb,YAAY,CAACY,KAAK,CAAC,CAE1C,GAAIC,cAAc,GAAK,IAAI,EAAIA,cAAc,GAAKC,SAAS,CAAE,CAC3DR,CAAC,CAACS,IAAI,CAACd,GAAG,CAACY,cAAc,CAAC,CAAC,CAC3BN,CAAC,CAACQ,IAAI,CAACb,KAAK,CAACW,cAAc,CAAC,CAAC,CAC7BL,CAAC,CAACO,IAAI,CAACZ,IAAI,CAACU,cAAc,CAAC,CAAC,CAC5BJ,CAAC,CAACM,IAAI,CAACX,OAAO,CAACS,cAAc,CAAC,CAAC,CACjC,CACF,CACA,MAAO,CAAEP,CAAC,CAADA,CAAC,CAAEC,CAAC,CAADA,CAAC,CAAEC,CAAC,CAADA,CAAC,CAAEC,CAAA,CAAAA,CAAE,CAAC,CACvB"}',
    version: "3.5.4"
};
var getInterpolateRGB = function() {
    var _e = [
        new global.Error(),
        -6,
        -27
    ];
    var anonymous = function anonymous(colors) {
        var r = [];
        var g = [];
        var b = [];
        var a = [];
        for(var i = 0; i < colors.length; ++i){
            var color = colors[i];
            var processedColor = (0, _Colors.processColor)(color);
            if (processedColor !== null && processedColor !== undefined) {
                r.push((0, _Colors.red)(processedColor));
                g.push((0, _Colors.green)(processedColor));
                b.push((0, _Colors.blue)(processedColor));
                a.push((0, _Colors.opacity)(processedColor));
            }
        }
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    };
    anonymous.__closure = {
        processColor: _Colors.processColor,
        red: _Colors.red,
        green: _Colors.green,
        blue: _Colors.blue,
        opacity: _Colors.opacity
    };
    anonymous.__initData = _worklet_8695722846819_init_data;
    anonymous.__workletHash = 8695722846819;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_14757969761783_init_data = {
    code: "function anonymous(colors){const{processColor,RGBtoHSV,red,green,blue,opacity}=this.__closure;const h=[];const s=[];const v=[];const a=[];for(let i=0;i<colors.length;++i){const color=colors[i];const processedColor=processColor(color);if(typeof processedColor==='number'){const processedHSVColor=RGBtoHSV(red(processedColor),green(processedColor),blue(processedColor));h.push(processedHSVColor.h);s.push(processedHSVColor.s);v.push(processedHSVColor.v);a.push(opacity(processedColor));}}return{h:h,s:s,v:v,a:a};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts",
    sourceMap: '{"version":3,"names":["anonymous","colors","processColor","RGBtoHSV","red","green","blue","opacity","__closure","h","s","v","a","i","length","color","processedColor","processedHSVColor","push"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts"],"mappings":"AAsJ0B,QACxB,CAAAA,SACDA,CAAoBC,MAAA,QAAAC,YAAA,CAAAC,QAAA,CAAAC,GAAA,CAAAC,KAAA,CAAAC,IAAA,CAAAC,OAAA,OAAAC,SAAA,CAEnB,KAAM,CAAAC,CAAC,CAAG,EAAE,CACZ,KAAM,CAAAC,CAAC,CAAG,EAAE,CACZ,KAAM,CAAAC,CAAC,CAAG,EAAE,CACZ,KAAM,CAAAC,CAAC,CAAG,EAAE,CACZ,IAAK,GAAI,CAAAC,CAAC,CAAG,CAAC,CAAEA,CAAC,CAAGZ,MAAM,CAACa,MAAM,CAAE,EAAED,CAAC,CAAE,CACtC,KAAM,CAAAE,KAAK,CAAGd,MAAM,CAACY,CAAC,CAAC,CACvB,KAAM,CAAAG,cAAc,CAAGd,YAAY,CAACa,KAAK,CAAQ,CACjD,GAAI,MAAO,CAAAC,cAAc,GAAK,QAAQ,CAAE,CACtC,KAAM,CAAAC,iBAAiB,CAAGd,QAAQ,CAChCC,GAAG,CAACY,cAAc,CAAC,CACnBX,KAAK,CAACW,cAAc,CAAC,CACrBV,IAAI,CAACU,cAAc,CACrB,CAAC,CAEDP,CAAC,CAACS,IAAI,CAACD,iBAAiB,CAACR,CAAC,CAAC,CAC3BC,CAAC,CAACQ,IAAI,CAACD,iBAAiB,CAACP,CAAC,CAAC,CAC3BC,CAAC,CAACO,IAAI,CAACD,iBAAiB,CAACN,CAAC,CAAC,CAC3BC,CAAC,CAACM,IAAI,CAACX,OAAO,CAACS,cAAc,CAAC,CAAC,CACjC,CACF,CACA,MAAO,CAAEP,CAAC,CAADA,CAAC,CAAEC,CAAC,CAADA,CAAC,CAAEC,CAAC,CAADA,CAAC,CAAEC,CAAA,CAAAA,CAAE,CAAC,CACvB"}',
    version: "3.5.4"
};
var getInterpolateHSV = function() {
    var _e = [
        new global.Error(),
        -7,
        -27
    ];
    var anonymous = function anonymous(colors) {
        var h = [];
        var s = [];
        var v = [];
        var a = [];
        for(var i = 0; i < colors.length; ++i){
            var color = colors[i];
            var processedColor = (0, _Colors.processColor)(color);
            if (typeof processedColor === "number") {
                var processedHSVColor = (0, _Colors.RGBtoHSV)((0, _Colors.red)(processedColor), (0, _Colors.green)(processedColor), (0, _Colors.blue)(processedColor));
                h.push(processedHSVColor.h);
                s.push(processedHSVColor.s);
                v.push(processedHSVColor.v);
                a.push((0, _Colors.opacity)(processedColor));
            }
        }
        return {
            h: h,
            s: s,
            v: v,
            a: a
        };
    };
    anonymous.__closure = {
        processColor: _Colors.processColor,
        RGBtoHSV: _Colors.RGBtoHSV,
        red: _Colors.red,
        green: _Colors.green,
        blue: _Colors.blue,
        opacity: _Colors.opacity
    };
    anonymous.__initData = _worklet_14757969761783_init_data;
    anonymous.__workletHash = 14757969761783;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_15267273840583_init_data = {
    code: "function interpolateColor(value,inputRange,outputRange,colorSpace='RGB',options={}){const{interpolateColorsHSV,getInterpolateHSV,interpolateColorsRGB,getInterpolateRGB}=this.__closure;if(colorSpace==='HSV'){return interpolateColorsHSV(value,inputRange,getInterpolateHSV(outputRange),options);}else if(colorSpace==='RGB'){return interpolateColorsRGB(value,inputRange,getInterpolateRGB(outputRange),options);}throw new Error(\"[Reanimated] Invalid color space provided: \"+colorSpace+\". Supported values are: ['RGB', 'HSV'].\");}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts",
    sourceMap: '{"version":3,"names":["interpolateColor","value","inputRange","outputRange","colorSpace","options","interpolateColorsHSV","getInterpolateHSV","interpolateColorsRGB","getInterpolateRGB","__closure","Error"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolateColor.ts"],"mappings":"AAiMO,SAAAA,gBAASA,CACdC,KAAA,CAAaC,UACb,CAA6BC,WAC7B,CAAyCC,UACzC,CAAyB,KAAG,CAAKC,OACjC,CAA6B,CAAI,CAAC,CACnC,OAAAC,oBAAA,CAAAC,iBAAA,CAAAC,oBAAA,CAAAC,iBAAA,OAAAC,SAAA,CAEC,GAAIN,UAAU,GAAK,KAAK,CAAE,CACxB,MAAO,CAAAE,oBAAoB,CACzBL,KAAK,CACLC,UAAU,CACVK,iBAAiB,CAACJ,WAAW,CAAC,CAC9BE,OACF,CAAC,CACH,CAAC,IAAM,IAAID,UAAU,GAAK,KAAK,CAAE,CAC/B,MAAO,CAAAI,oBAAoB,CACzBP,KAAK,CACLC,UAAU,CACVO,iBAAiB,CAACN,WAAW,CAAC,CAC9BE,OACF,CAAC,CACH,CACA,KAAM,IAAI,CAAAM,KAAK,+CACiCP,UAAW,0CAC3D,CAAC,CACH"}',
    version: "3.5.4"
};
var interpolateColor = exports.interpolateColor = function() {
    var _e = [
        new global.Error(),
        -5,
        -27
    ];
    var interpolateColor = function interpolateColor(value, inputRange, outputRange) {
        var colorSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "RGB";
        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
        if (colorSpace === "HSV") {
            return interpolateColorsHSV(value, inputRange, getInterpolateHSV(outputRange), options);
        } else if (colorSpace === "RGB") {
            return interpolateColorsRGB(value, inputRange, getInterpolateRGB(outputRange), options);
        }
        throw new Error("[Reanimated] Invalid color space provided: ".concat(colorSpace, ". Supported values are: ['RGB', 'HSV']."));
    };
    interpolateColor.__closure = {
        interpolateColorsHSV: interpolateColorsHSV,
        getInterpolateHSV: getInterpolateHSV,
        interpolateColorsRGB: interpolateColorsRGB,
        getInterpolateRGB: getInterpolateRGB
    };
    interpolateColor.__initData = _worklet_15267273840583_init_data;
    interpolateColor.__workletHash = 15267273840583;
    interpolateColor.__stackDetails = _e;
    return interpolateColor;
}();
var ColorSpace = exports.ColorSpace = function(ColorSpace) {
    ColorSpace[ColorSpace["RGB"] = 0] = "RGB";
    ColorSpace[ColorSpace["HSV"] = 1] = "HSV";
    return ColorSpace;
}({});
function useInterpolateConfig(inputRange, outputRange) {
    var colorSpace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ColorSpace.RGB;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return (0, _useSharedValue.useSharedValue)({
        inputRange: inputRange,
        outputRange: outputRange,
        colorSpace: colorSpace,
        cache: (0, _core.makeMutable)(null),
        options: options
    });
}
